export default {
  methods: {
    resetPageInfo(data) {
      return Object.assign(this.pageInfo, {
        total: data.length,
        currentPage: 1,
        pageSize: 20
      })
    }
  }
}
